import React from 'react';
import SectionHeader from '../../SectionHeader/SectionHeader';
import TimezoneSelection from '../../TimezoneSelection/TimezoneSelection';
import ErrorNotification from '../../ErrorNotification/ErrorNotification';
import TimeSlotsNotification from '../../TimeSlotsNotification/TimeSlotsNotification';
import WeekPicker from '../WeekPicker/WeekPicker';
import WeekAvailability from '../DeprecatedWeekAvailability/WeekAvailability';
import { WeeklyTimeSlotsLayoutViewModel } from '../../../ViewModel/bodyViewModel/bodyViewModel.types';
import { SlotsStatus } from '../../../../../types/types';
import { classes } from './WeeklyTimeSlotsLayout.st.css';
import { DataHooks } from './constants';
import TimeSlotsSelection from '../../TimeSlotsSelection/TimeSlotsSelection';
import { TimeSlotsSelectionViewModel } from '../../../ViewModel/timeSlotsSelectionViewModel/timeSlotsSelectionViewModel';
import { TimeSlotsSelectionDisplayMode } from '../../TimeSlotsSelection/constants';

export interface WeeklyTimeSlotsLayoutProps {
  viewModel: WeeklyTimeSlotsLayoutViewModel;
  errorNotificationText: string;
}

const WeeklyTimeSlotsLayout: React.FC<WeeklyTimeSlotsLayoutProps> = ({
  viewModel: {
    bodyTitle,
    slotsStatus,
    timeSlotsNotificationViewModel,
    timezoneSelectionViewModel,
    noAvailableSlotsViewModel,
    weekPickerViewModel,
    slotsPerDays,
  },
  errorNotificationText,
}) => {
  const dailySlotsFactory = (
    date: string,
    slotsViewModel: TimeSlotsSelectionViewModel,
  ) => {
    return slotsViewModel.timeSlots.length ? (
      <TimeSlotsSelection
        date={date}
        viewModel={slotsViewModel}
        displayMode={TimeSlotsSelectionDisplayMode.Column}
      />
    ) : null;
  };

  return (
    <div className={classes.root} data-hook={DataHooks.WeeklyTimeSlotsLayout}>
      <SectionHeader
        title={bodyTitle}
        suffix={
          <TimezoneSelection
            viewModel={timezoneSelectionViewModel}
            dataHook={DataHooks.Timezone}
          />
        }
      />
      <ErrorNotification errorText={errorNotificationText} />
      <WeekPicker viewModel={weekPickerViewModel!} />
      {slotsStatus === SlotsStatus.AVAILABLE_SLOTS ? (
        <TimeSlotsNotification viewModel={timeSlotsNotificationViewModel} />
      ) : null}
      <WeekAvailability
        slotsPerDays={slotsPerDays!}
        slotsStatus={slotsStatus}
        noAvailableSlotsViewModel={noAvailableSlotsViewModel!}
        dailySlotsFactory={dailySlotsFactory}
      />
    </div>
  );
};

export default WeeklyTimeSlotsLayout;
